import { createFileRoute, redirect } from '@tanstack/react-router';
import { influencersStaticData } from '../influencers';

export const Route = createFileRoute('/_private-routes/influencers/')({
  beforeLoad: () => {
    throw redirect({ to: '/influencers/search' });
  },
  staticData: influencersStaticData
});
